function productMenu() {
 let productNav = document.querySelector('.product-navigation');
 let href;
 let section;
 if(productNav) {
  let links = productNav.querySelectorAll('A');
  links.forEach(link => {
   link.addEventListener('click', (e) => {
    e.preventDefault();

    href = link.getAttribute('href');
    section = document.querySelector(`${href}`).getBoundingClientRect().top;

    setTimeout(() => {
     window.scrollBy({
      top: section,
      behavior: "smooth"
     })
    }, 100);
   })
  })
 }
}

productMenu()